import React, { useEffect, useState } from "react";
import { addQueryLocalStorage,removeQueryLocalStorage } from "../../../lib/utils";
import { useQueryParams } from "../../../lib/useQueryParams";
import { useLocation } from "react-router-dom";

const MemberShipFilter = (props) => {

  const location = useLocation();
  const [filterRadioList, setFilterRadioList] = useState(["Active", "Upcoming", "Past", "Transferred", "Upgraded"]);
  const [selectedFilter, setSelectedFilter] = useState("");
  const [filterByCancelledMembership, setFilterByCancelledMembership] = useState(false);
  const {getAllQueryParams} = useQueryParams();


  const handleSelectFilterType = (value) => {
    setSelectedFilter(value);
    addQueryLocalStorage('status',`${value}`.trim().split(" ").join('').toLowerCase())
  }

  const handleSelectSortBy = (value, checked) => {
    setFilterByCancelledMembership(checked);
    if(checked){
      addQueryLocalStorage('sortby', value)
    }else{
      removeQueryLocalStorage('sortby')
    }
  }


  // useEffect(()=>{
  //   let queryParams = getAllQueryParams();
  //   if(queryParams?.status){
  //     setSelectedFilter(queryParams.status[0].toUpperCase() + queryParams.status.slice(1))
  //   }
  //   if(queryParams?.sortby == "cancelled"){
  //     setFilterByCancelledMembership(true)
  //   }else{
  //     setFilterByCancelledMembership(false)
  //   }
  // }, [location.search])

   useEffect(()=>{
    let queryParams = getAllQueryParams();
    if(queryParams?.status){
      setSelectedFilter(queryParams.status[0].toUpperCase() + queryParams.status.slice(1))
    }else {
      setSelectedFilter("")
    }
    if(queryParams?.sortby == "cancelled"){
      setFilterByCancelledMembership(true)
    }else{
      setFilterByCancelledMembership(false)
    }
  }, [location.search])
  
  return(
    <div className="w-full">

      {
        props.header && ( 
          <p className="fs-16 font-weight-700 color-black m-b-12">Membership Filter</p>
        )
      }

      <p className="fs-14 font-weight-700 color-black m-b-12">Filter by Status</p>
      <div className="flex-item w-full m-t-12 m-b-12">
        {
          filterRadioList.map((data,index) => {
            return(
              <div onClick={()=>handleSelectFilterType(data)} className="d-flex m-b-12">
                <input type="radio" className="flex-item m-r-12" checked={selectedFilter == data ? true : false} style={{width:"22px", height:"22px"}} />
                <p className="flex-item fs-16" style={{fontWeight: selectedFilter == data ? 700 : 600, color: selectedFilter == data && "#055075"}}>{data}</p>
              </div>
            )
          })
        }
      </div>

      <p className="fs-14 font-weight-700 color-black  m-t-12 m-b-12">Other Filters</p>
      <div onClick={()=>handleSelectSortBy("cancelled",!filterByCancelledMembership)} className="d-flex m-t-12">
        <input type="checkbox" className="flex-item m-r-12" style={{width:"22px", height:"22px"}} checked={filterByCancelledMembership} />
        <p className="flex-item fs-16" style={{fontWeight: filterByCancelledMembership ? 700 : 600, color: filterByCancelledMembership && "#055075"}}> Sort By Cancelled</p>
      </div>
    </div>
  )
}

export default MemberShipFilter;